import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export interface LaboratoryService {
  id?: string;
  type: string;
  category?: string;
  price?: number;
  collectionMethod?: string;
  collectionPrice?: number;
  partner_id?: string;
}

export interface UpdateLaboratoryServiceProps {
  laboratoryServiceId: string;
  laboratoryService: Partial<LaboratoryService>;
}

export const useUpdateClinicLaboratoryService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation<any, any, UpdateLaboratoryServiceProps>({
    mutationFn: ({
      laboratoryServiceId,
      laboratoryService,
    }: UpdateLaboratoryServiceProps) => {
      return api.put(`clinic/lab-services/${laboratoryServiceId}`, {
        type: laboratoryService.type,
        category: laboratoryService.category,
        price: laboratoryService.price,
        collection_method: laboratoryService.collectionMethod,
        collection_price: laboratoryService.collectionPrice,
        partner_id: laboratoryService.partner_id,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "update-laboratory-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Clinic Laboratory Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
